var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"comment-list"},_vm._l((_vm.comments),function(comment){return _c('comment-item',{key:comment.id,attrs:{"value":comment}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }